import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {TicketPrice} from '../../../../../../projects/shared-lib/src/lib/models/ticket-price';
import {Location} from '../../../../../../projects/shared-lib/src/lib/models/location';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import {MailCategory, TicketDetailToken} from '../../../../../../projects/shared-lib/src/lib/models/ticket-detail-token';
import { HttpClient } from '@angular/common/http';
import {TicketsService} from '../../../tickets.service';
import {GiftTicketDialogComponent} from '../client-gift-ticket/client-gift-ticket-dialog/gift-ticket-dialog.component';
import {UnsendGiftDialogComponent} from '../client-gift-ticket/unsend-gift-dialog/unsend-gift-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SendTicketAsGiftResponse} from '../../../../../../projects/shared-lib/src/lib/models/send-ticket-as-gift-response';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CurrencyPipe } from '@angular/common';


@Component({
    selector: 'tw-client-ticket-line',
    templateUrl: './client-ticket-line.component.html',
    styleUrls: ['./client-ticket-line.component.css'],
    imports: [MatIconButton, MatButton, MatIcon, CurrencyPipe, TranslatePipe]
})
export class ClientTicketLineComponent implements OnInit, OnDestroy {
    @ViewChild('viewInfoTaxPrice', { read: ViewContainerRef }) entryInfoTaxPrice: ViewContainerRef;
    @Input() ticketPrice: TicketPrice;
    @Input() location: Location;
    @Output() displayPdf: EventEmitter<string> = new EventEmitter<string>();
    @Input()
    showDetailSeat = false;
    ticketsFileUrl: string;
    seatsFileUrl: string;
    ticketFileUrl: string[] = [];
    mail: MailCategory;
    ticketId: number;
    sendTicketAsGiftResponse: SendTicketAsGiftResponse;

    constructor(public translate: TranslateService,
                public http: HttpClient,
                private ticketService: TicketsService,
                private dialog: MatDialog
                ) {
    }

    ngOnInit() {
        this.mail = this.ticketPrice.upcomingTicketDetailTokens[0].mailCategory;
        this.ticketId = this.ticketPrice.upcomingTicketDetailTokens[0].sodId;
    }

    ngOnDestroy(): void {
        if (this.ticketsFileUrl) {
            URL.revokeObjectURL(this.ticketsFileUrl);
        }
        if (this.seatsFileUrl) {
            URL.revokeObjectURL(this.seatsFileUrl);
        }
    }

    isPrintableCategory(category: MailCategory) {
        return category === MailCategory.E_TICKETS || category === MailCategory.SMARTPHONE;
    }

    hasAnyGiftedTickets(): boolean {
        return this.ticketPrice.upcomingTicketDetailTokens.some(token => token.giftRecipient);
    }

    printTicket(mail: MailCategory, tokenIndex: number) {
        this.showDetailSeat = true;
        if (!this.ticketFileUrl[tokenIndex]) {
            this.ticketService.getTicketPdfForPrice(this.ticketPrice.upcomingTicketDetailTokens[tokenIndex]).subscribe((pdf) => {
                this.ticketFileUrl[tokenIndex] = URL.createObjectURL(pdf);
                this.displayPdf.emit(this.ticketFileUrl[tokenIndex]);
            });
        } else {
            this.displayPdf.emit(this.ticketFileUrl[tokenIndex]);
        }

    }

    printAllTickets(mail: MailCategory) {
        this.showDetailSeat = true;
        if (!this.ticketsFileUrl) {
            const sodIds: number[] = [];
            this.ticketPrice.upcomingTicketDetailTokens.forEach(token => {
                sodIds.push(token.sodId);
            });
            this.ticketService.getTicketsPdfForSodIds(sodIds, mail).subscribe((pdf) => {
                this.ticketsFileUrl = URL.createObjectURL(pdf);
                this.displayPdf.emit(this.ticketsFileUrl);
            });
        } else {
            this.displayPdf.emit(this.ticketsFileUrl);
        }
    }

    openSendTicketDialog(recipient?: string, sodId?: number) {
        const dialogRef = this.dialog.open(GiftTicketDialogComponent, {
            data: {
                sodId: sodId,
                email: recipient
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.sendTicketAsGiftResponse = result;
            console.log('Dialog closed with result:', result);
        });
    }

    cancelGift(sodId: number, recipientEmail: string) {
        const dialogRef = this.dialog.open(UnsendGiftDialogComponent, {
            data: {
                sodId: sodId,
                email: recipientEmail
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                console.log('Gift unsent successfully');
            }
        });
    }
}
